import { HEADER_OPTIONS_MAX_LENGTH, SEARCH_QUERY_GENERIC } from '../consts';
import {
  SearchOption,
  generateUrlFromSearchOption,
  getCountySearchOptions,
} from './searchOption.utils';
import { FlatType } from '../model/enums/flatType.enum';

export type BuyHouseOption = {
  flatType: string;
  query: string;
  text: string;
};

export const computeBuyHouseOptions = (
  searchOptions: SearchOption[],
  includeNonCountyOptions = false
): BuyHouseOption[] => {
  const filteredSearchOptions = includeNonCountyOptions
    ? searchOptions
    : getCountySearchOptions(searchOptions);
  filteredSearchOptions.sort((a, b) => {
    if (b.count === a.count) {
      return a.text?.localeCompare(b.text);
    }
    return b.count - a.count;
  });

  const flatType = FlatType.PISO;

  return [
    {
      flatType,
      query: SEARCH_QUERY_GENERIC,
      text: SEARCH_QUERY_GENERIC,
    },
    ...filteredSearchOptions
      .slice(0, includeNonCountyOptions ? undefined : HEADER_OPTIONS_MAX_LENGTH)
      .map((option) => ({
        flatType,
        query: generateUrlFromSearchOption(option),
        text: option.text,
      })),
  ];
};
